{
  "label-all-tag": "All"
}
